import { BsTelephone, BsCheckCircle, BsFileText, BsPeople, BsGear } from 'react-icons/bs';

import { colors } from '#styles/colors';

const ALPHA_10 = '1a';

const tone = (color, borderColor) => ({ color, bgColor: `${color}${ALPHA_10}`, borderColor });

export const ACTIVITY_TYPES = [
	{
		id: 'communication',
		label: 'Kommunikation',
		icon: BsTelephone,
		...tone(colors.primary[500], colors.primary[600]),
	},
	{ id: 'task', label: 'Aufgabe', icon: BsCheckCircle, ...tone(colors.success[700], colors.success[700]) },
	{ id: 'note', label: 'Notiz', icon: BsFileText, ...tone(colors.bgBase[800], colors.bgBase[800]) },
	{ id: 'meeting', label: 'Meeting', icon: BsPeople, ...tone(colors.caution[700], colors.caution[700]) },
	{
		id: 'stage_change',
		label: 'Phasen\u00e4nderung',
		icon: BsGear,
		...tone(colors.bgBase[700], colors.bgBase[600]),
	},
	{ id: 'system', label: 'System', icon: BsGear, ...tone(colors.bgBase[700], colors.bgBase[600]) },
];

/** Map for FullCalendar event coloring — keyed by activityType id */
export const ACTIVITY_COLORS = Object.fromEntries(
	ACTIVITY_TYPES.map((t) => [t.id, { backgroundColor: t.bgColor, borderColor: t.borderColor, color: t.color }]),
);

/** Get a single type config by id (falls back to first entry) */
export const getActivityType = (id) => ACTIVITY_TYPES.find((t) => t.id === id) ?? ACTIVITY_TYPES[0];

/** Only the user-facing types (excludes stage_change, system) */
export const USER_ACTIVITY_TYPES = ACTIVITY_TYPES.filter((t) => t.id !== 'stage_change' && t.id !== 'system');
